<template>
  <div class="my-watermark" :style="watermarkStyle" ref="watermakwnd">
    {{ markText }}
  </div>
</template>

<script>
export default {
  name: "water-mark",
  props: {
    text: {
      type: String,
      default: "水印内容",
    },
  },
  watch: {
    text: {
      immediate: true,
      async handler(newValue) {
        this.markText = newValue;
      }
    },
  },
  data() {
    return {
      bInit: false,
      x: 0,
      y: 0,
      directionX: 1,
      directionY: 1,
      markText: '',
    };
  },
  computed: {
    watermarkStyle() {
      return {
        position: "fixed",
        top: `${this.y}px`,
        left: `${this.x}px`,
        fontSize: "small",
        color: "rgba(0, 0, 0, 0.3)",
        pointerEvents: "none", // 确保水印不影响页面交互
        transform: "rotate(-30deg)",
        whiteSpace: "nowrap",
        zIndex: 999999,
      };
    },
  },
  mounted() {
    this.startFloating();
  },
  methods: {
    startFloating: function() {
      const speed = 2/3; // 控制水印移动速度
      const textWidth = this.$refs.watermakwnd.offsetWidth;
      const textHeight= this.$refs.watermakwnd.offsetHeight;
      const hAdjust = textHeight;
      const parent = this.$refs.watermakwnd.parentElement;
      let flag = 0;

      const updatePosition = () => {
        flag++;
        if(flag % 2 == 0) {
          if (!this.bInit) {
            let w = parent.offsetWidth;
            let h = parent.offsetHeight;
            if (w == 0 && h == 0) {
              requestAnimationFrame(updatePosition);
              return;
            }
            this.x = parent.offsetLeft;
            this.y = parent.offsetTop + hAdjust;
            this.bInit = true;
          }

          let left = parent.offsetLeft;
          let top = parent.offsetTop;
          let right = left + parent.offsetWidth;
          let bottom = top + parent.offsetHeight;

          // 更新水印位置
          this.x += this.directionX * speed;
          this.y += this.directionY * speed;

          // 检测边界并反向移动
          if (this.x <= left || this.x + textWidth >= right) {
            this.directionX *= -1;
          }
          if (this.y <= top + hAdjust || this.y + textHeight >= bottom - hAdjust) {
            this.directionY *= -1;
          }
        }

        requestAnimationFrame(updatePosition);
      };

      updatePosition();
    },
  },
}
</script>

<style scoped>
.my-watermark {
  user-select: none; /* 禁止用户选中水印 */
}
</style>
